export enum ProposalStatus {
  PENDING = "pending",
  REVIEWED = "reviewed",
  INTERVIEWED = "interviewed",
  ACCEPTED = "accepted",
  REJECTED = "rejected",
  CANCELED = "canceled",
}

export enum ProposalInterviewStatus {
  ACTIVE = "active",
  PENDING = "pending",
}

export enum ProposalInterviewType {
  WALK_IN = 'walk_in',
  VIDEO_CALL = 'video_call',
}

export type ProposalInterview = {
  createdAt: string;
  interviewSchedule: string;
  notes: string;
  proposalId: string;
  reason: string;
  status: ProposalInterviewStatus;
  type: ProposalInterviewType;
  updatedAt: string;
}

export type Proposal = {
  activeInterview: ProposalInterview;
  status: ProposalStatus;
  createdAt: string;
  proposalable: {
    vacancyId: string;
  };
}